import { Navigate, Outlet, useLocation } from "react-router-dom";
import { hasPgToken } from "../pgApi";

/**
 * PG 頁面的登入守門：沒有 pg_token 就導到登入頁，登入後回到原頁。
 * token 過期由 api_pg 的 401 攔截清掉，下一次渲染就會被導回來。
 */
const PgLoginGuard = () => {
	const location = useLocation();

	if (!hasPgToken()) {
		const redirect = encodeURIComponent(location.pathname + location.search);
		return <Navigate to={`/pg/login?redirect=${redirect}`} replace />;
	}

	return <Outlet />;
};

export default PgLoginGuard;
